import { render, staticRenderFns } from "./myDelegate.vue?vue&type=template&id=e0d58958&scoped=true&"
import script from "./myDelegate.vue?vue&type=script&lang=js&"
export * from "./myDelegate.vue?vue&type=script&lang=js&"
import style0 from "./myDelegate.vue?vue&type=style&index=0&id=e0d58958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d58958",
  null
  
)

export default component.exports